import { computed, type Env } from './env.type.ts';

export const env: Env = {
  ...computed,
  buildTarget: 'web',
  // 구독 게이트는 전 환경 defer(=false) — BE 시딩 완료 후 일괄 전환.
  subscriptionGateEnabled: true,
  // 운영만 비활성 — 결제 오픈 전까지 구독 퍼널 전체를 채널톡 문의 안내로 돌린다(오픈 시 true).
  tossPaymentEnabled: false,
  // 표 엑셀 내보내기 — web 빌드 전용(native 는 CAN_EXPORT_XLSX 의 빌드 상수 항에서 이미 걸린다).
  canExportXlsx: true,
  // 운영 배포 도메인.
  deployBaseUrl: 'https://app.heviton.com',
  // GA4 — 브라우저·앱(WebView) 공용 스트림. 운영에만 둔다(dev·temp 는 지표 오염 방지로 미설정).
  // native.production 이 이 파일을 상속하므로 앱도 같은 property 로 모인다.
  gaMeasurementId: 'G-KEFRKFM2GH',
  api: {
    appLegacy: { baseUrl: 'https://api.heviton.com:8443' },
    v2: { baseUrl: 'https://api.heviton.com:9443' },
    // web-legacy = /api/2.0 (v2 와 동일 BE host).
    webLegacy: { baseUrl: 'https://api.heviton.com:9443' },
  },
  // Toss client key. 평소 운영 = 헤리트 라이브 키.
  // ⚠️ 빌링 심사 제출 시에만: 아래 라이브를 주석 처리하고 헤리트 '테스트' 키로 교체해 빌드 → 제출 → 원복.
  //   (빌링은 Toss 승인 후 활성 — 개발은 공개 테스트 키(web.local/development)로. docs/payment-method-decisions.md §2)
  // tossClientKey: 'test_ck_ZLKGPx4M3MG46KWK64O4rBaWypv1', // 헤리트 테스트 (심사 제출용 — 제출 후 원복)
  tossClientKey: 'live_ck_26DlbXAaV0Oz7vDjYmYq3qY50Q9R', // 헤리트 라이브 (운영)
  // web push — prod 프로젝트(heviton-prd). 웹 앱 등록 + VAPID 키쌍 발급 완료. 값은 공개값(클라이언트 번들 노출).
  firebase: {
    apiKey: 'AIzaSyC_7vv5RWJC5dlxQpYulAo8t5auAxBvV4M',
    authDomain: 'heviton-prd.firebaseapp.com',
    projectId: 'heviton-prd',
    storageBucket: 'heviton-prd.firebasestorage.app',
    messagingSenderId: '1043875437496',
    appId: '1:1043875437496:web:884d5c926f8794ae9c4d4d',
    measurementId: 'G-0H9KNSFQ1G',
    vapidKey:
      'BISNx9FD32y_hxhhMLEWTPJgvAD-d19nJi32yiuqwua6Gkbl_9wfAV2c7TiDQagS1eKttkQRbdVOT8LN0Fv33y8',
  },
};
